function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  }
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from 'react';
import { Button, TextField } from '4finance-components';
import translate from '4finance-translate';
import { email, isRequired, maxLength, minLength, regex, number, password } from '4finance-validation';
import { connectField, connectSubmit } from '4finance-onion-form';
/**
 * Add translate and connection wrappers to field component
 * @param {String} name Name of the field
 * @param {Object} defaultProps Default properties for field component
 * @param {Array} validations Validations for the field
 * @returns {Function} Connected with translate props wrapped component
 */

function translatedField(name, defaultProps, validations) {
  return function (FieldComponent) {
    return translate(connectField(name, defaultProps, validations)(FieldComponent));
  };
}
export var Email = function Email(_ref) {
  var name = _ref.name,
    bordered = _ref.bordered,
    fieldProps = _ref.fieldProps;
  var _fieldProps$validatio = fieldProps.validations,
    validations = _fieldProps$validatio === void 0 ? [] : _fieldProps$validatio,
    prefix = fieldProps.prefix,
    includePrefix = fieldProps.includePrefix,
    props = _objectWithoutProperties(fieldProps, ["validations", "prefix", "includePrefix"]);
  var EmailInput = translatedField(name, _objectSpread({
    type: 'email',
    bordered: bordered
  }, props), [isRequired(), maxLength(90), email()].concat(_toConsumableArray(validations)))(TextField);
  return React.createElement(EmailInput, {
    prefix: prefix,
    includePrefix: includePrefix
  });
};
export var Phone = function Phone(_ref2) {
  var name = _ref2.name,
    regexp = _ref2.regexp,
    bordered = _ref2.bordered,
    fieldProps = _ref2.fieldProps;
  var _fieldProps$validatio2 = fieldProps.validations,
    validations = _fieldProps$validatio2 === void 0 ? [] : _fieldProps$validatio2,
    prefix = fieldProps.prefix,
    includePrefix = fieldProps.includePrefix,
    props = _objectWithoutProperties(fieldProps, ["validations", "prefix", "includePrefix"]);
  var PhoneInput = translatedField(name, _objectSpread({
    type: 'tel',
    bordered: bordered
  }, props), [isRequired(), maxLength(15), regex(regexp)].concat(_toConsumableArray(validations)))(TextField);
  return React.createElement(PhoneInput, {
    prefix: prefix,
    includePrefix: includePrefix
  });
};
export var Code = function Code(_ref3) {
  var name = _ref3.name,
    bordered = _ref3.bordered,
    fieldProps = _ref3.fieldProps;
  var _fieldProps$validatio3 = fieldProps.validations,
    validations = _fieldProps$validatio3 === void 0 ? [] : _fieldProps$validatio3,
    prefix = fieldProps.prefix,
    includePrefix = fieldProps.includePrefix,
    props = _objectWithoutProperties(fieldProps, ["validations", "prefix", "includePrefix"]);
  var CodeInput = translatedField(name, _objectSpread({
    type: 'tel',
    bordered: bordered
  }, props), [isRequired(), number(), minLength(6), maxLength(6)].concat(_toConsumableArray(validations)))(TextField);
  return React.createElement(CodeInput, {
    prefix: prefix,
    includePrefix: includePrefix
  });
};
export var Password = function Password(_ref4) {
  var name = _ref4.name,
    bordered = _ref4.bordered,
    fieldProps = _ref4.fieldProps,
    strongPassword = _ref4.strongPassword,
    customPasswordValidation = _ref4.customPasswordValidation;
  var _fieldProps$validatio4 = fieldProps.validations,
    validations = _fieldProps$validatio4 === void 0 ? [] : _fieldProps$validatio4,
    prefix = fieldProps.prefix,
    includePrefix = fieldProps.includePrefix,
    props = _objectWithoutProperties(fieldProps, ["validations", "prefix", "includePrefix"]);
  var PasswordInput = translatedField(name, _objectSpread({
    type: 'password',
    bordered: bordered
  }, props), [isRequired()].concat(_toConsumableArray(customPasswordValidation ? [customPasswordValidation()] : [minLength(6), maxLength(30), password({
    strong: strongPassword
  })]), _toConsumableArray(validations)))(TextField);
  return React.createElement(PasswordInput, {
    prefix: prefix,
    includePrefix: includePrefix
  });
};
export var SubmitButton = connectSubmit(Button);